import { Component, Input } from "@angular/core";
import { Banque } from "../../../interfaces/Banque";

@Component({
  selector: "app-informations",
  templateUrl: "./informations.component.html",
  standalone: false,
})
export class InformationsComponent {
  @Input() banque: Banque;
}
